__turbopack_context__.v({
  "caret": "d8crTq_caret",
  "compact": "d8crTq_compact",
  "panel": "d8crTq_panel",
  "panelHead": "d8crTq_panelHead",
  "pill": "d8crTq_pill",
  "popover": "d8crTq_popover",
  "popoverOpen": "d8crTq_popoverOpen",
  "row": "d8crTq_row",
  "wrapper": "d8crTq_wrapper",
});
